import gql from 'graphql-tag';

const RESET_SUBSCRIPTION_SWITCH_COUNT = gql`
  mutation resetSubscriptionSwitchCount($_id: String!) {
    resetSubscriptionSwitchCount(_id: $_id) {
      _id
      firstName
      lastName
      email
    }
  }
`;

export default RESET_SUBSCRIPTION_SWITCH_COUNT;
